'use client';

import { FloatingPortal } from '@floating-ui/react';
import { useContext } from 'react';

import { MenuRootContext } from './context/menu-root.context';
import type { MenuPortalPropsInterface } from './types/menu-portal.types';

/**
 * @since 10.0.0
 */
export const MenuPortal = (props: MenuPortalPropsInterface) => {
  const { menu } = useContext(MenuRootContext);

  if (!menu.isMounted) {
    return null;
  }

  return <FloatingPortal {...props} />;
};

MenuPortal.displayName = 'Menu.Portal';
